export default __webpack_public_path__ + "static/ads-img-fb029684780ad71ca610c4547bcbbbbb.png";